import stringFormat from 'string-format'

export function fragFormat(frag) {
  return function format(data) {
    return stringFormat(frag, data)
  }
}
